//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ButtonDropdown',
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: ''
    },
    mainButtonClass: {
      type: String,
      default: ''
    }
  }
}
